<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class="main-div">
        <el-container class="parentDiv">
          <div class="SID0006_newsScrollPage" >
            <div class="sliderOne" v-loading.fullscreen.lock="fullscreenLoading">
              <!-- Breadcrumb section -->
              <section>
                <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegisterLink">
                  <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                  <el-breadcrumb-item :to="{ path: '' }">サムネイル表示 (EL記事)</el-breadcrumb-item>
                </el-breadcrumb>
              </section>
              <!--Fix for BT08460_EXTERNAL-1596 by MA starts here-->
              <section>
                <el-dialog title=""
                    :visible.sync="dialogVisible "
                    close="false"
                    :close-on-click-modal="false"
                    class="SID0009_DilaogDiv PrintHideArea">
                  <el-container>
                    <div class="SID0009__popupScreen3">
                        <div class="FirstSpan3">
                            <span>要求された記事は表示できません。</span>
                        </div>  
                        <div class="ButtonClose3">
                            <el-button type="info" plain @click="closeTab">閉じる</el-button>
                        </div>
                    </div>
                  </el-container>
                </el-dialog>
              </section>
              <!--Fix for BT08460_EXTERNAL-1596 by MA ends here-->
              <!-- Full container div statrt -->
              <!-- BT08460_EXTERNAL-1572 issue fix by MA - Oct 30 -->
              <span class="prev prevButtonTopSpan" v-show="showPrev">
                <el-button type="primary" @click="prev()" plain>前へ</el-button>
              </span>
              <span class="next nextButtonTopSpan" v-show="showNext">
                <el-button type="primary" @click="next()" plain>次へ</el-button>
              </span>
              <div class="owl-carousel owl-theme" v-if="refresh" v-carousel>
                <div class="divScrollSection"  v-for="(mcArticle,index) in this.getArrayMC" v-bind:key="index">
                  <!-- Topic Header section -->
                  <section>
                    <el-row>
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                      <el-col :span="3" :xs="24">
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                        <div class="newsScrollImage">
                          <img src="../../assets/image/logo-new.png" alt="LOGO" />
                        </div>
                      </el-col>
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                      <el-col :span="21" :xs="24">
                      <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                        <div class="TopicHeaderText">
                          <span>
                            {{ mcArticle.article_title }}
                          </span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-divider class="newsScrollHeaderTop"></el-divider>
                    <el-row>
                      <el-col :span="3" class="ColumnFirst">{{ mcArticle.media_name }}</el-col>
                      <el-col :span="4">{{ mcArticle.issue_date }}</el-col>
                      <el-col :span="3">{{ mcArticle.articleEdition }}</el-col>
                      <el-col :span="3">{{ mcArticle.frame_no }}面 </el-col>
                      <el-col :span="3">{{ mcArticle.head_no }}段 </el-col>
                      <el-col :span="5">{{ mcArticle.article_class }}</el-col>
                      <el-col :span="3">枚数({{mcArticle.image_count}})</el-col>
                    </el-row>
                    <el-divider class="newsScrollHeaderBottom"></el-divider>
                  </section>
                  <!-- Notic information section -->
                  <section>
                    <div class="noticInformation">
                      <span >&lt;注記&gt;</span>
                      <span>{{ mcArticle.note }}</span> 
                      <br>
                      <span>&lt;コメント&gt;</span>
                      <span v-html="mcArticle.article_comment"></span>
                      <br>
                      <span>&lt;検索語&gt;</span>
                      <span>{{ mcArticle.search_word }}</span> 
                    </div>
                    <el-divider class="newsScrollHeaderMiddle"></el-divider>
                  </section>
                  <!-- Slider section -->
                  <section>
                    <div class="LinkThumbnailPrint">
                      <!-- 2022/08/09  #13105  START -->
                      <!-- <div v-if="mc_user_authority == 3 && mcArticle.mcPdfPrintDisplayFlag == true"> -->
                      <div v-if="mc_user_authority == 3 && mcArticle.no_image_flag == false">
                      <!-- 2022/08/09  #13105  END -->
                        <!-- Change by CK for backlog Id: 1420  -->
                      <el-link :underline="false" type="primary" class="ArticleLink">
                        サムネイルをクリックすると記事原文を表示します。
                        <el-link :underline="false" type="primary"  class="ArticleLink">印刷は<b @click="pdfPrint(mcArticle.article_id,mcArticle.data_section)" class="ArticlePrintText">ここ</b>から指定してください。</el-link>
                      </el-link>
                      </div>
                      <!-- 2022/08/09  #13105  START -->
                      <!-- <div v-else-if="mc_user_authority == 1 || mcArticle.mcPdfPrintDisplayFlag == false"></div> -->
                      <div v-else-if="mc_user_authority == 1 || mcArticle.no_image_flag == true"></div>
                      <!-- 2022/08/09  #13105  END -->
                      <div v-else-if="mc_user_authority == 2">
                        <el-link :underline="false" type="primary" class="ArticleLink">
                        サムネイルをクリックすると記事原文を表示します
                      </el-link>
                      </div>
                      <el-row>
                        <!-- 2021/02/23 #10026 START-->
                        <!--<el-carousel indicator-position="none" :autoplay="false">-->
                        <el-carousel indicator-position="none" :autoplay="false" :arrow="mcArticle.mcimagelink.length==1?'never':'hover'">
                          <!-- 2021/02/23 #10026 END-->
                        <el-carousel-item v-for="item in mcArticle.mcimagelink" :key="item">
                            <!-- 2022/08/31  #13105  START -->
                            <!-- <div v-if="(mc_user_authority == 2 || mc_user_authority == 3) && mcArticle.mcPdfPrintDisplayFlag == true" class="slider_outer"> -->
                            <div v-if="(mc_user_authority == 2 || mc_user_authority == 3) && mcArticle.no_image_flag == false" class="slider_outer">
                            <!-- 2022/08/31  #13105  END -->
                              <el-image :src="item" @error="replaceByDefault($event,index)" alt="ArticleSnap" class="sliderImage" style="cursor: pointer" @click="sendToErrorDisplay(mcArticle.article_id)"/>
                            </div>
                            <div v-else class="slider_outer">
                              <el-image :src="item" @error="replaceByDefault($event,index)" alt="ArticleSnap" class="sliderImage b-none"/>
                            </div>
                        </el-carousel-item>
                      </el-carousel>
                    </el-row>
                    </div>
                    <div class="button_text">
                      <el-button @click="viewText(mcArticle.article_id)" v-if="canViewText && mcArticle.no_text_flag == false" type="primary"  plain>テキスト</el-button>
                    </div>
                    <el-divider class="newsScrollHeaderMiddle"></el-divider>
                  </section>
                  <!-- Swiper bottom section -->
                  <section>
                    <div class="swiperBottomInfo">
                      <div>&lt;ELNETのキーワード&gt;</div>
                      <div> {{ mcArticle.keyword }} </div>
                      <!-- /*** Change by CK for backlog Id: 1629 */ -->
                      <div> {{ mcArticle.free_keyword }} </div>
                      <div>
                        <el-link  @click="isShowing = true"  class="linkMore" :underline="false" type="primary">もっと見る</el-link>
                      </div>
                      <div v-show="isShowing"> {{ mcArticle.subword }} </div>
                    </div>
                  </section>
                </div>
              </div>
              <span class="prev prevBottomSpan" v-show="showPrev">
                <el-button type="primary" @click="prev()" plain>前へ</el-button>
              </span>
              <span class="next nextButtonBottomSpan" v-show="showNext">
                <el-button type="primary" @click="next()" plain>次へ</el-button>
              </span>
              <!-- Full container div end -->
            </div>
          </div>
        </el-container>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<!-- BT08460_EXTERNAL-1572 issue fix by MA - Oct 29 -->
<script type="text/javascript" src="../../../public/script/owl.carousel.js"></script>
<script>
import Header from "../common/header.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import "splitpanes/dist/splitpanes.css";
import "swiper/dist/css/swiper.css";
import Vue from 'vue'
import Common from '../../common/CommonFunc.js';
// 2022/08/09  #13105  START 
// import error_image from "../../assets/image/errorThumbnailImage@3_200x200.png";
import error_image_no_image from "../../assets/image/errorThumbnail@3_200x200.png";
import error_image_no_auth from "../../assets/image/errorThumbnailImage@3_200x200.png";
// 2022/08/09  #13105  END
import router from "../../router";
/***********BT08460_EXTERNAL-1572 issue fix by MA - Oct 30***********/
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel';
// 2024/08/19  #13914  START
import { onMounted } from 'vue';
// 2024/08/19  #13914  END
export default {
// 2024/08/19  #13914  START
  setup() {
    onMounted(() => {
      if (/iP(hone|od|ad).*Safari/i.test(navigator.userAgent)) {
        // Safariの場合、キャッシュ表示のままになるので強制リロード
        window.location.replace(window.location.href);
      }
      });
    },
// 2024/08/19  #13914  END
  name: "NewsScroll",
  props: {
    items: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Header,
    FooterComponent,
  },
  data() {
    return {
      // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30 starts here
      showPrev: false,
      showNext: true,
      refresh: false,
      // 2022/02/14  #12197  START
      repeat:false,
      // 2022/02/14  #12197  END
      nextSlideDataSection: 1,
      prevSlideDataSection: 1,
      getArrayMC: [],
      // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30 ends here
      mc_user_authority:'3',
      canViewText: false,
      canViewPdf: false,
      print_text_confirm_message_flag: "",
      hideNavButton: true,
      hideNextButton_0007: false,
      hidePrevButton_0007: false,
      fullscreenLoading: false,
      isShowing:false,
      loading:false,
      id:'',
      logo:Common.El_Logo,
      userId:'',
      contractId:'',
      theme_browsing:false,
      contract_code:'',
      message_info: [],
      pdf_confirm_message_flag: "",
      text_confirm_message_flag: "",
      print_confirm_message_flag: "",
      user_group_name: "",
      is_mail:false,
      inputParam: "",
      currentNewsCount: 0,
      currentStartNum:1,
      currentAID:"",
      loadNum: 10,
      dialogVisible: false, // Fix for BT08460_EXTERNAL-1596 by MA
      queryparam:'',
      frommail:false,
      currentSID:'',
      currentArticleNo:0,
      fromSID:'',
    };
  },
  methods: {

    // Fix for BT08460_EXTERNAL-1596 by MA starts here
    closeTab(){
      this.$LogButtonEvent("0007","Close");
      this.$LogMethodIN("0007","closeTab");
      router.push("0002");
      this.$LogMethodOut("0007","closeTab");
    },
    // Fix for BT08460_EXTERNAL-1596 by MA ends here
    replaceByDefault(event, index) {
      this.getArrayMC[index].mcPdfPrintDisplayFlag = false;
      // 2022/08/09  #13105  START
      // event.target.src = error_image;
      if(this.getArrayMC[index].no_image_flag == true)
      {
        // 原文提供不可場合、「この記事は、著作権処理等の関係で記事原文やサムネイルのご提供ができません。」
        event.target.src = error_image_no_auth;
      }
      else{
        // 原文提供可場合、「この記事は、サムネイルが取得できませんでした。」
        event.target.src = error_image_no_image;
      }
      // 2022/08/09  #13105  END
    },
    sendToErrorDisplay(article_id){
      this.$LogButtonEvent("0006","Close");
      this.$LogMethodIN("0006","sendToErrorDisplay");
      // 2022/02/14  #12197  START
      if(this.repeat){
        return
      }
      this.repeat = true;
      // 2022/02/14  #12197  END
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: article_id,
            data_section: 1
          }
        ],
        user_id: this.userId,
        contract_code: this.contract_code,
        theme_browsing: this.theme_browsing,
        // 2021/10/11  #11849  START
        display_id: 'SID0006',
        // 2021/10/11  #11849  END
        is_mail: this.is_mail
      };
       var printSuccessValues = {
        data_info:[{
        contract_id: this.contractId,
        data_section: 1,
        user_id: this.userId,
        read_count:1,
        request_div:1,
        article_id: article_id,
        user_group_name: this.user_group_name,
        
        }],
        is_mail:this.is_mail
      }
      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', printCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                // 2022/02/14  #12197  START
                setTimeout(() => {
                        this.repeat = false;
                    }, 60);
                // 2022/02/14  #12197  END
                /*this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                  // 2022/02/14  #12197  START
                  this.repeat = false;
                  // 2022/02/14  #12197  END
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                done();
              }else{
                // 2022/02/14  #12197  START
                this.repeat = false;
                // 2022/02/14  #12197  END
                done();
              }
            }
          }
        );
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', printCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        // 2022/02/14  #12197  START
        setTimeout(() => {
                this.repeat = false;
            }, 60);
        // 2022/02/14  #12197  END
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
      this.$LogMethodOut("0006","sendToErrorDisplay");
    },
    viewText (article_id) {
      this.$LogButtonEvent("0006","Text");
      this.$LogMethodIN("0006","viewText");
      var articleDetails = {
        articleId: article_id,
        data_section: 1,
        is_mail:false,
        // 2021/10/11  #11849  START
        display_id: 'SID0006',
        // 2021/10/11  #11849  END
      };
      if(this.getOut_Demand_Confirm_Message_Div_Flag){
        this.$confirm(this.getDemandConfirmTextMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm")
            {
              let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
              window.open(routeData.href, '_blank');
              done();
            }
            else
            {
              done();
            }
          }
        });
      }else{
        let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("0006","viewText");
    },
    getMessageInfoFromSession(){
      var message_info = this.message_info
      for(var u=0;u<message_info.length;u++)
      {
        if(message_info[u].message_key == "demandConfirmPrintTextMessage")
        {
          this.print_text_confirm_message_flag = message_info[u].configuration_value;
        }
        else if(message_info[u].message_key == "demandConfirmPdfMessage")
        {
          this.pdf_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmTextMessage")
        {
          this.text_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmPrintMessage")
        {
          this.print_confirm_message_flag = message_info[u].configuration_value
        }
        else
        {

          //no action needed
        }
      }
    },
    //for next button
    next(){
      this.currentArticleNo = this.currentArticleNo + 1;
      this.nextSlideDataSection = this.getArrayMC[this.currentArticleNo].data_section;
      if(this.nextSlideDataSection == '2'){
        // 2021/12/7  #12178  START
        if(this.getOut_Demand_Confirm_Message_Div_Flag){
          this.$confirm(this.getDemandConfirmTextMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                Vue.prototype.$session.set('CurrentRowNo',this.currentArticleNo);                
                Vue.prototype.$session.set('Article_Id',this.getArrayMC[this.currentArticleNo].article_id);
                if(router.currentRoute.name != '0007'){
                  router.push({name:'0007',query: this.queryparam});
                }
              }else{
                done();
              }
            }
          });
        }else{
          Vue.prototype.$session.set('CurrentRowNo',this.currentArticleNo);
          Vue.prototype.$session.set('Article_Id',this.getArrayMC[this.currentArticleNo].article_id);
          if(router.currentRoute.name != '0007'){
            router.push({name:'0007',query: this.queryparam});
          }
        }
        // 2021/12/7  #12178  END
      }else{
        this.prevSlideDataSection = this.getArrayMC[this.currentArticleNo - 1].data_section;
      }
    },
    //for prev button
    prev(){
      this.currentArticleNo = this.currentArticleNo - 1;
      this.prevSlideDataSection = this.getArrayMC[this.currentArticleNo].data_section;
      if(this.prevSlideDataSection == '2'){
        // 2021/12/7  #12178  START
        if(this.getOut_Demand_Confirm_Message_Div_Flag){
          this.$confirm(this.getDemandConfirmTextMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                Vue.prototype.$session.set('CurrentRowNo',this.currentArticleNo);
                Vue.prototype.$session.set('Article_Id',this.getArrayMC[this.currentArticleNo].article_id);
                if(router.currentRoute.name != '0007'){
                  router.push({name:'0007',query: this.queryparam});
                }
              }else{
                done();
              }
            }
          });
        }else{
          Vue.prototype.$session.set('CurrentRowNo',this.currentArticleNo);
          Vue.prototype.$session.set('Article_Id',this.getArrayMC[this.currentArticleNo].article_id);
          if(router.currentRoute.name != '0007'){
            router.push({name:'0007',query: this.queryparam});
          }
        }
        // 2021/12/7  #12178  END
      }else{
        this.prevSlideDataSection = this.getArrayMC[this.currentArticleNo + 1].data_section;
      }
    },
    // For click the print link 
    pdfPrint(articleid,datasection){
      var pdfValues = {
        pdf_flag:2,
        article_info:[
            {
              article_id: articleid,
              data_section: datasection
            }
          ],
          user_id:this.userId,
          contract_code:this.contract_code,
          theme_browsing:this.theme_browsing,
          // 2021/10/11  #11849  START
          display_id: 'SID0006',
          // 2021/10/11  #11849  END
          is_mail:this.is_mail
      }
      var printSuccessValues = {
        data_info:[{
          contract_id: this.contractId,
          data_section: datasection,
          user_id: this.userId,
          read_count:1,
          request_div:2,
          article_id: articleid,
          user_group_name: this.user_group_name,
        }],
        is_mail:this.is_mail
      }
      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPrintMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })
                done();
              }
              else
              {
                done();
              }
            }
          }
        );
      }
      else
      {
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
    },
    createData(){
      var session_mcArticle = this.getNewsArticledata;
      // Fix for BT08460_EXTERNAL-1596 by MA
      if(session_mcArticle != "" && session_mcArticle.length > 0){
        this.fullscreenLoading = false;
        this.getArrayMC = session_mcArticle;
      }else{
        this.dialogVisible = true; // Fix for BT08460_EXTERNAL-1596 by MA
        this.fullscreenLoading = false;
      }
    },
  },
  created(){
    //For the screen Title
    document.title = "記事閲覧";
  },
  computed: {
    ...mapGetters("situation0006", [
      // 2021/11/22  #12270  SATRT
      "getCurrentNewsCount",
      "getCurrentRowNo",
      // 2021/11/22  #12270  END
      "getNewsArticledata",
    ]),
    ...mapGetters("situation0001", [
      "getMcUserAuthority",
      "getUserId",
      "getContractId",
      "getThemeBrowsing",
      "getContractCode",
      "getMC_Pdf_View_Flag",
      "getMC_Text_View_Flag",
      "getMessageInfo",
      "getUserGroupName",
      "getOut_Demand_Confirm_Message_Div_Flag",
      "getDemandConfirmPdfMessage",
      "getDemandConfirmTextMessage",
      // 2021/10/11  #11849  SATRT
      "getUserGroup_News_Article_Flag",
      "getMC_Article_Flag",
      // 2021/10/11  #11849  END
      "getDemandConfirmPrintMessage"])
  },
  mounted(){
    this.fullscreenLoading = true;
    // 2021/10/11  #11849  SATRT
    if(!this.getUserGroup_News_Article_Flag || !this.getMC_Article_Flag){
      this.dialogVisible = true
    }
    // 2021/10/11  #11849  END
    //get the user id value from session
    this.userId = this.getUserId

    //get the contract_id value from session
    this.contractId = this.getContractId

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing

    //get the pdf print flag from the session
    this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag

    //get the contract code value from session
    this.contract_code = this.getContractCode
    this.user_group_name = this.getUserGroupName

    this.mc_user_authority =  this.getMcUserAuthority
    this.canViewText = this.getMC_Text_View_Flag
    this.message_info = this.getMessageInfo
    var mail_processor = new Common.Mail_URL_Processor(this.$route.query)
    var having_mail_key = mail_processor.is_data_present("is_mail")
    var getDataArticleIds = [];
    if(having_mail_key)
    {
      // 2026/03/09 #20277 START
      var ua = navigator.userAgent;
      var isMobileSafari = /iPhone|iPad|iPod/.test(ua) && /WebKit/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
      if (isMobileSafari && window.location.search.indexOf('v=') === -1) {
        history.replaceState(null, '', '/?v=' + Date.now() + window.location.hash);
      }
      // 2026/03/09 #20277 END
      var mc_articleids = mail_processor.get_mc_article_details()
      if(mc_articleids.length>0)
      {
        Array.prototype.push.apply(getDataArticleIds,mc_articleids); 
      }
      var sc_articleids = mail_processor.get_sc_article_details()
      if(sc_articleids.length>0)
      {
        Array.prototype.push.apply(getDataArticleIds,sc_articleids); 
      }
      this.queryparam = this.$route.query
      this.frommail = true
    }
    this.getMessageInfoFromSession();
    if(!this.dialogVisible){
          if(getDataArticleIds.length > 0){
          //Removed this code since it is not calling the API on same tab  - mail link carousel issue fix by DK - Nov 04
          // BT08460_EXTERNAL-1572 mail link carousel issue fix by GB - Nov 03
          // if(this.getNewsArticledata.length > 0)
          // {
          //   this.refresh = true;
          //   this.createData();

          //   if(Vue.prototype.$session.get('CurrentNewsCount'))
          //   {
          //     this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
          //   }

          //   if(Vue.prototype.$session.get('CurrentRowNo'))
          //   {
          //     this.currentArticleNo= Vue.prototype.$session.get('CurrentRowNo');
          //   }
          // }
          // else
          // {
          //   this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds,}).then(() => {
          //     this.createData();
              
          //     if(Vue.prototype.$session.get('CurrentNewsCount'))
          //     {
          //       this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
          //     }
          //     this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
          //   })

          // }
          // 2024/08/05  #17046 No.20  START
          if(Vue.prototype.$session.get('CurrentRowNo')){
            this.currentArticleNo= Vue.prototype.$session.get('CurrentRowNo');
          }
          // 2024/08/05  #17046 No.20  END
          // 2024/08/05  #17046 No.20  START
          //this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds,}).then(() => {
          this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds, image_flag: true}).then(() => {
          // 2024/08/05  #17046 No.20  END
            this.createData();
            
            if(Vue.prototype.$session.get('CurrentNewsCount'))
            {
              this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
            }
            // 2021/10/11  #11849  SATRT
            else{
              this.dialogVisible = true
            }
            // 2021/10/11  #11849  END
            this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
          })
          
        }else {
          this.inputParam = Vue.prototype.$session.get('InputParameterFor0006');
          this.currentNewsCount = Vue.prototype.$session.get('CurrentNewsCount');
          this.currentAID = Vue.prototype.$session.get('CurrentAID');
          this.currentSID = Vue.prototype.$session.get('CurrentSID');
          if(Vue.prototype.$session.get('CurrentRowNo')){
            this.currentArticleNo= Vue.prototype.$session.get('CurrentRowNo');
          }
          // 2024/08/05  #17046 No.20  START
          this.inputParam.image_flag = true;
          // 2024/08/05  #17046 No.20  END
          //Removed this code since it is already handled in the directive
          // if(this.currentArticleNo == this.currentNewsCount - 1){
          //   this.showNext = false;
          // }
          if(this.getNewsArticledata.length > 0){
            this.refresh = true;
            this.createData();
          }else{
            switch(this.currentAID)
            {
              case "0005":
                if(this.currentSID == "0002"){
                  this.currentStartNum = 1;
                  this.currentSlideNo = 1;
                  this.inputParam.start_num = 1;
                  this.inputParam.load_num = this.currentNewsCount;
                }
                else{
                  this.currentStartNum = this.inputParam.start_num;
                  this.currentSlideNo = this.inputParam.start_num;
                }
                // 2021/11/22  #12270  SATRT
                this.inputParam.Article_Id=Vue.prototype.$session.get('Article_Id');
                this.inputParam.Samuneiru_flag=1;
                // 2021/11/22  #12270  END
                this.$store.dispatch('communication0006/getNewspaperArticles', this.inputParam).then(() => {
                  this.createData();
                  // 2021/11/22  #12270  SATRT
                  this.currentNewsCount= this.getCurrentNewsCount;
                  this.currentArticleNo= this.getCurrentRowNo;
                  // 2021/11/22  #12270  END
                  this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
                })
                break;
              case "0071":
                if(this.currentSID == "0002"){
                  this.currentStartNum = 1;
                  this.currentSlideNo = 1;
                  this.inputParam.start_num = 1;
                  this.inputParam.load_num = this.currentNewsCount;
                  this.inputParam.contract_kbn = 1;
                }else{
                  this.currentStartNum = this.inputParam.start_num;
                  this.currentSlideNo = this.inputParam.start_num;
                  this.inputParam.contract_kbn = 1;
                }
                this.$store.dispatch('communication0006/getArticleUsingSearch', this.inputParam).then(() => {
                  this.createData();
                  this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
                })
                break;
              case "0046":
                this.currentStartNum = 0;
                this.currentSlideNo = 0;
                this.$store.dispatch('communication0006/AID0046_Get', this.inputParam).then(() => {
                  this.createData();
                  this.refresh = true;  // BT08460_EXTERNAL-1572 issue fix by MA - Oct 30
                })
                break;
              //2025/05/21  #19462  START
              case "0109":
                this.$store.dispatch('communication0006/AID0109_Get', this.inputParam).then(() => {
                  this.createData();
                  this.refresh = true;
                })
                break;
                //2025/05/21  #19462  END
            }
          }
        }
    }
    /******Issue fix for 1563 ******/
    if("SID"+this.currentSID == "SID1023"){
      this.fromSID = "SID1024";
    }else{
      this.fromSID = "SID"+this.currentSID;
    }
  },
  directives: {
    carousel: {
      inserted(el, binding, vnode) {
        var toSlideNo = vnode.context.currentArticleNo;
        console.log('toSlideNo: ', toSlideNo);
        var owl = $('.owl-carousel').owlCarousel({
            loop: false,
            nav: true,
            items: 1,
        }).trigger('to.owl.carousel', [toSlideNo,0]);

        /****To hide next button when single record is obtained*****/
        if(vnode.context.currentNewsCount  == 1){
          vnode.context.showNext = false;
        }
        /****To show previous button when showing record other than first record*****/
        if(toSlideNo  > 0){
          vnode.context.showPrev = true;
        }
        /****To hide next button when showing last record*****/
        if(vnode.context.currentNewsCount - 1 == toSlideNo){
          vnode.context.showNext = false;
        }

        /********Event handler for previous and next button********/
        $('.prev').click(function() {
          owl.trigger('prev.owl.carousel');
        });
        $('.next').click(function() {
          owl.trigger('next.owl.carousel');
        });

        /********Event handler for changed event******/
        owl.on('changed.owl.carousel', (event) => {
          vnode.context.isShowing = false;

          // start
          if (event.item.index === 0) {
            vnode.context.showPrev = false;
            vnode.context.showNext = true;
          } else {
            const currnetel = Math.floor(event.item.index + event.page.size);
            // last
            if (currnetel === event.item.count) {
              vnode.context.showPrev = true;
              vnode.context.showNext = false;
            } else {
              vnode.context.showPrev = true;
              vnode.context.showNext = true;
            }
          }

          /*****Code to handle transition between SID0006 and SID0007 when swipe event occurs***/
          var currentDataSection = vnode.context.getArrayMC[event.item.index].data_section;
          if(currentDataSection == '2'){
            Vue.prototype.$session.set('CurrentRowNo',event.item.index);
            if(router.currentRoute.name != '0007'){
              router.push({name:'0007',query: vnode.context.queryparam});
            }
          }
        });

      },
    }
  }
};
</script>
<style scoped>
@import "0006.css";
@import "../0009/0009.css";
</style>